import { combineSlices } from '@reduxjs/toolkit';
import { zigbeeAttributesSlice } from './ZigbeeAttributesSlice';
export default combineSlices(zigbeeAttributesSlice);
